import React, { FC } from "react";

import { Box } from "@shared/aviary/bloomer";

import { EnterCode } from "../EnterCode";
import { TwoFactorTitle } from "../TwoFactorTitle";

import "./TwoFactorLoginPage.scss";

interface Props {
  isSms: boolean;
  mobileNumber?: string;
  goToNextStep?: () => void;
  healthwave_site_name: string;
  healthwave_support_email: string;
  healthwave_practitioner_phone_number: string;
}

const TwoFactorLoginPage: FC<Props> = ({
  isSms,
  goToNextStep,
  mobileNumber,
  healthwave_site_name,
  healthwave_support_email,
  healthwave_practitioner_phone_number,
}) => {
  return (
    <div className="two-factor-login-page">
      <Box>
        <TwoFactorTitle title="Two-Factor Verification" />
        <EnterCode
          isSms={isSms}
          goToNextStep={goToNextStep}
          isLogin={true}
          mobileNumber={mobileNumber}
        />
      </Box>
      <p className="two-factor-login-help-text">
        If you need help logging in, please contact {healthwave_site_name}'s customer support team
        at <a href="mailto:{healthwave_support_email}">{healthwave_support_email}</a> or{" "}
        <a href="tel:{healthwave_practitioner_phone_number}">
          {healthwave_practitioner_phone_number}
        </a>
      </p>
    </div>
  );
};

export { TwoFactorLoginPage };
